// Floating action button (ADR-0047, UI-13).
//
// The tasks screen is a list; adding is a FAB. Previously the add-task form
// lived permanently in the page under the list, which put the primary
// action mid-screen with an empty bottom third when the list was short, and
// pushed it below the fold when the list was long. Neither is where a thumb
// is.
//
// Icon-only, so it carries a localized aria-label (ADR-0036). Sits above
// the fixed tab bar and clear of the phone's safe-area inset — both derive
// from the same --nav-h token the bar uses, so it cannot drift out of
// alignment with it.

import { el } from '../dom.js';
import { icons } from '../icons.js';

export function fab(opts: { label: string; onClick: () => void }): HTMLElement {
  return el(
    'button',
    {
      class: 'fab',
      type: 'button',
      id: 'add-task-fab',
      'aria-label': opts.label,
      title: opts.label,
      onclick: opts.onClick,
    },
    icons.plus(),
  );
}
